import { render, staticRenderFns } from "./KGridItem.vue?vue&type=template&id=07e4b50f&scoped=true&"
import script from "./KGridItem.vue?vue&type=script&lang=js&"
export * from "./KGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e4b50f",
  null
  
)

export default component.exports